// extracted by mini-css-extract-plugin
export default {"productCardContainer":"ProductDashboard_productCardContainer__VHQHT","productsSection":"ProductDashboard_productsSection__8sIUI"};